import { InfoResourcesPackage } from "../../resources/InfoResourcesPackage";
import { BasePage } from "./BasePage";
import { TextStyle } from "@pixi/text";
import { Sprite } from "@pixi/sprite";
import { FitText } from "../../../common/components/FitText";
import { Localization } from "../../../common/Localization";
import { getDefaultFontFamily } from "../../../common/TextUtils";

export class SpecBlockAndMoreScorePage extends BasePage {
    private refresh: Sprite;
    private refreshInfo: FitText;
    private move: Sprite;
    private moveInfo: FitText;
    private erase: Sprite;
    private eraseInfo: FitText;

    public constructor(
        private readonly infoResources: InfoResourcesPackage,
        private readonly localization: Localization
    ) {
        super();
        this.build();
        this.layout();
    }

    private build(): void {
        this.refresh = new Sprite(this.infoResources.assets_info_refresh_png);
        this.refreshInfo = new FitText(this.localization.getText("info_text_refresh"), this.getInfoTextStyle(), 700, 150);

        this.move = new Sprite(this.infoResources.assets_info_erase_triangles_png);
        this.moveInfo = new FitText(this.localization.getText("info_text_move"), this.getInfoTextStyle(), 700, 150);

        this.erase = new Sprite(this.infoResources.assets_info_erase_png);
        this.eraseInfo = new FitText(this.localization.getText("info_text_erase"), this.getInfoTextStyle(), 700, 150);

        this.addChild(this.refresh, this.refreshInfo, this.move, this.moveInfo, this.erase, this.eraseInfo);
    }

    private layout(): void {
        this.refresh.position.set((this.width - this.refresh.width) * 0.5, 0);
        this.refreshInfo.position.set((this.width - this.refreshInfo.width) * 0.5, 140);
        this.move.position.set((this.width - this.move.width) * 0.5, 240);
        this.moveInfo.position.set((this.width - this.moveInfo.width) * 0.5, 390);
        this.erase.position.set((this.width - this.erase.width) * 0.5, 530);
        this.eraseInfo.position.set((this.width - this.eraseInfo.width) * 0.5, 670);
    }

    private getInfoTextStyle(): TextStyle {
        return new TextStyle({
            fontFamily: getDefaultFontFamily(),
            fontSize: 36,
            fill: "#4A5F66",
            align: "center"
        });
    }
}